import React from "react";

export default function HRCalendar() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">HR Calendar</h1>
      <p>View company holidays, events, and important HR dates here.</p>

      {/* Example placeholder calendar */}
      <ul className="mt-4 space-y-2">
        <li className="bg-gray-700 p-2 rounded">🎄 Dec 25 – Christmas Holiday</li>
        <li className="bg-gray-700 p-2 rounded">🗓 Dec 31 – Year-End Performance Review</li>
        <li className="bg-gray-700 p-2 rounded">📅 Jan 1 – New Year Holiday</li>
      </ul>
    </div>
  );
}
